// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/element-variables.scss'
import DateFormatter from './utils/scripts'

import "babel-polyfill"

Vue.config.productionTip = false

Vue.use(VueCookie)
Vue.use(ElementUI)
DateFormatter()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js